import HTTP from '@/plugins/axios';

// Short facts of one job ad (the ad text itself is the showangex.php page)
export interface JobInfo {
  date?: string
  position?: string
  location?: string
  firmname?: string
}

export const getJobInfo = async(params: { sid: string, job_id: number }): Promise<JobInfo> => {
  const response = await HTTP.get('/jobnews/jobinfo', { params });
  return response.data;
};

// Contact data of a job ad: where to apply and the company address
export interface JobContact {
  company_name?: string
  salutation?: number
  firstname?: string
  lastname?: string
  street?: string
  street_no?: string
  plz?: string
  city?: string
  phone?: string
  email?: string
  homepage?: string
  apply_url?: string
}

export const getJobContact = async(params: { sid: string, job_id: number }): Promise<JobContact | null> => {
  const response = await HTTP.get('/jobnews/google_map_job', { params });
  return Array.isArray(response.data) ? response.data[0] || null : null;
};

// The address of the ad on its source site (empty for ads entered on our portal)
export const getJobUrl = async(params: { sid: string, job_id: number }): Promise<string> => {
  const response = await HTTP.get('/jobnews/get_job_url', { params });
  return response.data?.url || '';
};
